module.exports = __webpack_public_path__ + "img/logo-ccn-cert.d3540d7.png";